/**
 * A save that keeps the doctor validation must not recompute the validated totals: the
 * doctor signed off on that dose, and the patient's weight/BSA/GFR may have changed since
 * (e.g. a nurse recorded a new weight before a note-only edit).
 */
export function getMedicineTotalAmount(calculatedTotalAmount, prevMedicine, keepValidatedTotal) {
    if (keepValidatedTotal && prevMedicine?.totalAmount != null)
        return prevMedicine.totalAmount;
    return calculatedTotalAmount;
}
/**
 * A dose that rounds to 0 at the prescribed precision is no dose (CY-317), so the save refuses it.
 * Checked on the server only, so a client without the patient's values synced never refuses a valid save.
 */
export function assertTotalAmountsNotZero(tx, totalAmounts) {
    if (tx.location !== 'server')
        return;
    if (totalAmounts.some(totalAmount => totalAmount === null || totalAmount <= 0)) {
        throw new Error('Total amount cannot be zero');
    }
}
//# sourceMappingURL=medicine-total-amount.js.map